<template>
  <div class="templa"></div>
</template>
<script>
export default {
  name: 'templa',
  /*  prop属性只读 不可直接修改 会影响性能以及维护性 */
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  data() {
    return {};
  },
  created() {},
  mounted() {
    /* 获取初始值 */
  },
  methods: {},
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.templa {
  width: 100%;
  box-sizing: border-box;
}
</style>
